var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SpinnerArea',{attrs:{"state":_vm.spinner}},[(_vm.errorContent)?_c('ErrorTemplate',{attrs:{"page-content":_vm.errorContent},on:{"button-back-to-overview-click":function($event){return _vm.handleButtonBackToOverviewClick()}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }